export const ASSETS = {
  logo: "/assets/navx-logo.jpg",
  naty: "/assets/bot-naty.jpg",
  momo: "/assets/bot-momo.jpg",
  aizen: "/assets/bot-aizen.jpg",
  hano: "/assets/bot-hano.jpg",
  zora: "/assets/bot-zora.jpg",
  madara: "/assets/bot-madara.jpg",
  gameVideo: "/assets/navx-game.mp4",
  lito: "/assets/lito-memorial.webp",
};

export const WHATSAPP_URL = "https://wa.me/556896142378";
export const WHATSAPP_DISPLAY = "(68) 9614-2378";
export const EMAIL = "Natanael.oliveira.ac@gmail.com";

export const MEMORIAL_UNTIL = "2026-10-03T00:00:00-03:00";

export const BOT_STATUS = {
  naty: true,
  aizen: true,
  hano: false,
  zora: false,
  momo: false,
  madara: false,
};
